import * as React from "react";
import { DataMessages, useData, useDataValue } from "../core/hooks/useData";
import { usePresenter, usePresenterEvents } from "./types";
import { closestIndex } from "../core/utils/dom";
import { newID } from "../core/utils/unique";
import { ReadOnlyValue } from "./ReadOnlyValue";

const all = [
    { name: "Pty Ltd", isPublic: false },
    { name: "Pty. Ltd.", isPublic: false },
    { name: "Pty Limited", isPublic: false },
    { name: "Pty. Limited", isPublic: false },
    { name: "Proprietary Ltd", isPublic: false },
    { name: "Proprietary Ltd.", isPublic: false },
    { name: "Proprietary Limited", isPublic: false },
    { name: "Ltd", isPublic: true },
    { name: "Ltd.", isPublic: true },
    { name: "Limited", isPublic: true },
    // { name: "No-liability", isPublic: true },

    { name: "PTY LTD", isPublic: false },
    { name: "PTY. LTD.", isPublic: false },
    { name: "PTY LIMITED", isPublic: false },
    { name: "PTY. LIMITED", isPublic: false },
    { name: "PROPRIETARY LTD", isPublic: false },
    { name: "PROPRIETARY LTD.", isPublic: false },
    { name: "PROPRIETARY LIMITED", isPublic: false },
    { name: "LTD", isPublic: true },
    { name: "LTD.", isPublic: true },
    { name: "LIMITED", isPublic: true },
    // { name: "NO-LIABILITY", isPublic: true },
    { name: "NL", isPublic: true },
];

export function LegalElement(props: {

    prop: string;
    className?: string;

}) {
    const data = useData();
	const value = useDataValue(data, props.prop);
	const presenter = usePresenter();

	const id = React.useRef<string>();
	if (!id.current) id.current = newID();

	
	const [state, setState] = React.useState({
		companyType: presenter.getValue("companyType", { dataState: data }),
		howAppear: presenter.getValue("howAppear", { dataState: data }),
	});

	const {
		companyType, howAppear
	} = state;

	usePresenterEvents(
		presenter, 
		React.useCallback((msg: any) => {
			if (msg.type === DataMessages.CHANGE) {
				const newCompanyType = presenter.getValue("companyType", { dataState: data });
				const newHowAppear = presenter.getValue("howAppear", { dataState: data });

				if ((newCompanyType !== companyType) || (newHowAppear !== howAppear)) {
					setState({
						companyType: newCompanyType,
						howAppear: newHowAppear,
					})
				}
			}
		}, [presenter, companyType, data, howAppear]),
	);

	const isPublic = companyType && (companyType.indexOf("Public") >= 0);
    const isByShares = companyType && (companyType.indexOf("By Shares") >= 0);
	const isAllCaps = (howAppear === "All Caps");

	const {
        className,
        prop,
    } = props;

    var left = [] as any[], right = [] as any[];
    for(var i=0;i<all.length;i++) {
        const le = all[i];
        const arr = (le.name.toUpperCase() === le.name) ? right : left;
        const radioID = id.current + "_" + i;

        if (le.isPublic && !isPublic) continue;
        if (!le.isPublic && isPublic) continue;

        if (le.name === "NL" && !isByShares) continue;

		if (isAllCaps) {
			// filter out any which aren't all caps options
			if (le.name !== le.name.toUpperCase()) {
				// just check in case this was actually the current chosen value
				if (le.name === value) {
					// for moment just clear out the value
					data.setValue(prop, "");
				}
				continue;
			}
		}

        arr.push(
            <div key={le.name} className="flex horiz gap-5">
                <input
                    type="radio"
                    className="radio"
                    name={id.current}
                    id={radioID}
                    onChange={handleClick}
                    data-index={i} 
                    checked={le.name === value}
                />
                <label htmlFor={radioID}>{le.name}</label>
            </div>
        );
    }

    function handleClick(e: any) {
        const index = closestIndex(e.target, ".radio");
        if (index < 0) return;

        const {
            prop,
        } = props;

        const val = all[index].name;

		data.setValue(prop, val);
	}

	if (presenter.readOnly) {
		return (
			<ReadOnlyValue>{value}</ReadOnlyValue>
		);
	}


    return (
        <div
            className={[className, "form-control legal-element flex horiz padding-5"].join(" ")}
			style={{border:"none"}}
            onClick={handleClick}
        >
            <div className="left">{left}</div>
            <div className="right">{right}</div>
        </div>
    );


}

